import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
import App from './App.vue'
import router from './router'
import { store } from './state'
import { auth } from './auth/auth'
import vuetify from './plugins/vuetify'

Vue.use(VueCompositionAPI)

Vue.config.productionTip = (process.env.environment === 'DEVELOPMENT')

async function bootstrap() {
  auth.initialize()
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount('#app')
}

bootstrap()
